export const defaultBussBar = {
  keyword: '', // 搜索关键字
  questionID: undefined, // 联想选中的题目
  department: undefined, // 科室
  showQuestion: false, // 是否展示联想区域
  showAnswer: false, // 是否展示答案区域
  innerAnswer: '', // 内部知识库答案
  thirdAnswer: '', // 第三方AI大模型答案
  aiQuestionID: undefined // 第三方AI大模型问题id
}
